/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { verifyUserAttributePostRequestSchema } from './verifyUserAttributePostRequestSchema.ts';
import { verifyUserAttributePostResponseSchema } from './verifyUserAttributePostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postVerifyUserAttribute200Schema = z.lazy(() => verifyUserAttributePostResponseSchema);

/**
 * @description 505 response
 */
export const postVerifyUserAttribute505Schema = z.any();

export const postVerifyUserAttributeMutationRequestSchema = z.lazy(() => verifyUserAttributePostRequestSchema);

export const postVerifyUserAttributeMutationResponseSchema = z.lazy(() => postVerifyUserAttribute200Schema);
